import * as React from "react";
import YouTube from "react-youtube";
console.log(YouTube);

interface YoutubePlayerProps {
    list: string;
    visible: boolean;
}

export class YoutubePlayer extends React.Component<YoutubePlayerProps, {}> {
    constructor(props: YoutubePlayerProps) {
        super(props);
    }

    render(): JSX.Element {
        let w = 250;
        let h = w * 9.0 / 16.0;
        const opts = {
            width: "" + w + "px",
            height: "" + h + "px",
            playerVars: { // https://developers.google.com/youtube/player_parameters
              autoplay: 1,
              controls: 0,
              disablekb: 1,
              fs: 0,
              iv_load_policy: 3,
              listType: "playlist",
              list: this.props.list,
              loop: 1,
              modestbranding: 1,
              showinfo: 0
            }
          };
        return <div className="clickable" style={{opacity: this.props.visible ? 1 : 0, transition: "all 0.2s linear"}}><YouTube
        opts={opts}
        onReady={this.onReady}
      /></div>;
    }

    onReady(event) {
        event.target.mute();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/youtubePlayer.tsx